export default function StatusDot({
  status,
  pulse = false,
}: {
  status: "ok" | "warn" | "run" | "idle";
  pulse?: boolean;
}) {
  return <span className={`dot ${status} ${pulse ? "pulse" : ""}`} />;
}
